import Trash from '../../assets/svg/Trash.svg';
import AvatarCard from '../avatar-card';
interface AvatarProps {
    item: any;
    onClickItem?: any;
    className?: any;
    handleRemoveFile?: any;
}

export default function AttachementFile({ item, onClickItem, className, handleRemoveFile }: AvatarProps) {

    return (
        <div
            className={`flex justify-between w-full chip !p-2 !rounded-basicRadius !bg-white !border-feildBorder !border-0 items-center ${className}`}
            onClick={() => onClickItem ? onClickItem(item) : {}}
        >
            <div>
                <AvatarCard imageUrl={item.profilePic} title={item.label} subTitle={item.position} size="md" isViewMore={false} />
            </div>
            <div>
                <img src={Trash} alt="Remove file" className="cursor-pointer rounded-basicRadius border-2 border-feildBorder  p-1.5 hover:border-primary" onClick={(e: any) => { e.stopPropagation(); handleRemoveFile() }} />
            </div>
        </div>
    );
};